import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-app_talk",
  "use": "icon-app_talk-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-app_talk\"><path d=\"M792.576 0q19.456 0 36.352 7.168t29.696 19.968 19.968 29.696 7.168 36.352l0 837.632q0 38.912-27.136 66.048t-66.048 27.136l-559.104 0q-38.912 0-66.048-27.136t-27.136-66.048l0-837.632q0-19.456 7.168-36.352t19.968-29.696 29.696-19.968 36.352-7.168l559.104 0zM419.84 93.184l185.344 0 0-47.104-185.344 0 0 47.104zM512 976.896q19.456 0 36.352-7.168t29.696-19.968 19.968-29.696 7.168-36.352-7.168-36.352-19.968-29.184-29.696-19.456-36.352-7.168q-38.912 0-65.536 26.624t-26.624 65.536 26.624 66.048 65.536 27.136zM792.576 139.264l-559.104 0 0 605.184 559.104 0 0-605.184z\" p-id=\"2178\" fill=\"#e61805\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/map/app_talk.svg
// module id = UQ/W
// module chunks = 24